import React, { forwardRef } from 'react';
import Label from '../Label';
import useBlockingEffect from '../hooks/useBlockingEffect';
import { useSuperFieldContext } from '../SuperField';
var SuperFieldLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      alwaysShrank = _ref.alwaysShrank;

  var _useSuperFieldContext = useSuperFieldContext(),
      id = _useSuperFieldContext.id,
      onLabelShrank = _useSuperFieldContext.onLabelShrank,
      onLabelExpand = _useSuperFieldContext.onLabelExpand,
      isFocused = _useSuperFieldContext.isFocused,
      isInputFilledIn = _useSuperFieldContext.isInputFilledIn,
      isLabelShrank = _useSuperFieldContext.isLabelShrank;

  useBlockingEffect(function () {
    if (isInputFilledIn || isFocused || alwaysShrank) {
      onLabelShrank();
    } else {
      onLabelExpand();
    }
  }, [isFocused, isInputFilledIn]);
  return /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    ref: ref,
    sx: {
      position: 'absolute',
      top: 0,
      left: 0,
      transition: 'color 200ms ease, transform 200ms ease 0ms',
      transform: isLabelShrank ? 'translate(0, 0) scale(0.75)' : 'translate(0, 16px)',
      transformOrigin: 'top left',
      color: 'inherit'
    }
  }, children);
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
SuperFieldLabel.displayName = 'SuperFieldLabel';
export default SuperFieldLabel;